import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { getEpgNow } from '../../other/epg-database';
import EpgRow from './Epg';

const EpgSummary = styled.div`
  margin-top: 1rem;
  max-height: 40vh;
  overflow: hidden;
  transition: all 0.3s ease;
  cursor: ${(props) => (props.$isExpanded ? 'default' : 'pointer')};
  width: 100%;
  box-sizing: border-box;
`;

const EpgListing = ({ Epg, Shift }) => {
  const timer = useSelector((state) => state.timer60);

  const [epgListing, setEpgListing] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false);
  const timeoutRef = useRef(null);

  useEffect(() => {
    const arr = getEpgNow(Epg, Shift);
    if (!arr || arr.length === 0) setEpgListing([]);
    else setEpgListing(arr);
  }, [Epg, Shift]);

  useEffect(() => {
    const arr = getEpgNow(Epg, Shift);
    if (!arr || arr.length === 0) setEpgListing([]);
    else if (arr && arr.length > 0 && epgListing.length > 0) {
      if (arr[0].start !== epgListing[0].start) setEpgListing(arr);
    } else if (
      arr &&
      arr.length > 0 &&
      (!epgListing || epgListing.length === 0)
    ) {
      setEpgListing(arr);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timer, Epg, Shift]);

  // Detectar mudança de canal e expandir automaticamente
  useEffect(() => {
    if (Epg) {
      setIsExpanded(true);
      // Limpar timer anterior se existir
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      // Minimizar após 3 segundos
      timeoutRef.current = setTimeout(() => {
        setIsExpanded(false);
      }, 3000);
    }
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [Epg]);

  // Handler para expandir ao clicar quando minimizado
  const handleToggle = () => {
    if (!isExpanded) {
      setIsExpanded(true);
      // Reiniciar timer de 3 segundos
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = setTimeout(() => {
        setIsExpanded(false);
      }, 3000);
    }
  };

  const programsToShow = isExpanded ? 4 : 1;

  return (
    <EpgSummary $isExpanded={isExpanded} onClick={handleToggle}>
      {epgListing.slice(0, programsToShow).map((epg, id) => (
        <EpgRow
          key={Epg + ' ' + id}
          first={id === 0}
          start={epg.start}
          stop={epg.end}
          title={epg.title}
          description={epg.description}
        />
      ))}
    </EpgSummary>
  );
};

export default EpgListing;
